import { CP261Tooltip } from '../PracticeProfileTooltips'

import { UploadItem } from './UploadItem'
import { Text } from '@/ui'
import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

export const FormCP261UploadItem = ({
  businessEntity,
  uploadButtonOnly,
}: {
  businessEntity?: string
  uploadButtonOnly?: boolean
}) => {
  return (
    <UploadItem
      label="CP261 Letter"
      popUpContent={<CP261Tooltip />}
      documentCategory={UserDocumentCategoryIdentifier.cp261Notice}
      additionalTrackingProperties={{
        document_category: 'cp261_letter',
        business_entity: businessEntity,
      }}
      uploadButtonOnly={uploadButtonOnly}
    >
      <Text>
        The CP261 Notice is an official confirmation of your S Corporation
        election approval status. If you&apos;ve lost your CP261 Notice, you
        can&apos;t request another copy of it. However, you can request an S
        Corporation verification letter (known as Form 385C) by calling the IRS
        at 1-800-829-4933. You can upload either here.
      </Text>
    </UploadItem>
  )
}
